import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=78b3e008&scoped=true&"
import script from "./AddressList.vue?vue&type=script&scoped=true&lang=js&"
export * from "./AddressList.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./AddressList.vue?vue&type=style&index=0&id=78b3e008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b3e008",
  null
  
)

export default component.exports